import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { PHONE } from "../../data/content";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
  { to: "/legacy", label: "Legacy" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="bg-[#12281a] text-[#f7f5f0] border-b border-[#12281a]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex items-center justify-between text-[11px] tracking-widest uppercase">
          <div className="flex items-center gap-4">
            <span className="text-[#b38b47] font-semibold">Growing with Integrity</span>
            <span className="hidden sm:inline text-[#f7f5f0]/40">|</span>
            <span className="hidden sm:inline text-[#f7f5f0]/70" data-testid="topbar-entity">
              Jaybhaye Realty Pvt. Ltd. · Apratim Group
            </span>
          </div>
          <a
            href={`tel:+91${PHONE}`}
            data-testid="topbar-phone-link"
            className="text-[#f7f5f0]/80 hover:text-[#b38b47] transition-colors"
          >
            Direct Desk: <strong className="text-[#b38b47] font-semibold">{PHONE}</strong>
          </a>
        </div>
      </div>

      <nav className="sticky top-0 z-40 bg-[#f7f5f0]/95 backdrop-blur-md border-b border-[#12281a]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
            <img
              src="/assets/jb-mark.png"
              alt="Jaybhaye Realty Pvt. Ltd. logo"
              className="h-12 w-auto object-contain"
              loading="eager"
            />
            <span className="flex items-baseline gap-2">
              <span className="font-monument text-xl sm:text-2xl font-bold tracking-tight text-[#12281a]">
                JAYBHAYE
              </span>
              <span className="text-xs uppercase tracking-[0.2em] text-[#b38b47] font-medium">REALTY</span>
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-8 text-xs uppercase tracking-[0.18em] text-[#12281a]/75 font-semibold">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `transition-colors hover:text-[#b38b47] ${isActive ? "text-[#b38b47]" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              data-testid="nav-enquire-button"
              className="hidden sm:inline-block px-6 py-2.5 bg-[#12281a] hover:bg-[#1f422b] text-[#f7f5f0] text-xs uppercase tracking-widest font-semibold transition-colors"
            >
              Enquire
            </Link>
            <button
              className="lg:hidden p-2 text-[#12281a]"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-[#12281a]/10 bg-[#f7f5f0]" data-testid="mobile-menu">
            <div className="px-6 py-4 flex flex-col gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `py-3 text-sm uppercase tracking-[0.18em] font-semibold border-b border-[#12281a]/10 ${
                      isActive ? "text-[#b38b47]" : "text-[#12281a]/80"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
